import { useEffect, useState } from "react";
import ToolBar from "../../../../components/ToolBar";
import RecordPerPage from "../../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import { setPerPage, setDetails, deleteRecord, fetchList } from "./utils/slice";
import DeleteModal from "../../../../components/Modals/DeleteModal";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import EditComponent from "./components/Form/EditComponent";
import { CMSSettingsBreadcrumb } from "../../../../config/BreadcrumbConfig";
import { toUpperCaseWithUnderscore } from "../../../../utils/commonFunctions";
import { useAppSelector } from "../../../../utils/hooks/hooks";

const moduleInfo = {
  title: "Cms Page",
  permissionKeyPrefix: toUpperCaseWithUnderscore("cms"),
};

/**
 * Renders the Cms component.
 *
 * @return {JSX.Element} The Cms component.
 */
const Cms: React.FC<any> = () => {
  const dispatch: AppDispatch = useDispatch();
  const {perPage} = useAppSelector(state => state.cmsPages);
  const [editDrawer, setEditDrawer] = useState(false);
  const [deleteValue, setDeleteValue] = useState<any>();

  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);
  
  return (
    <>
      <ToolBar breadcrumbs={CMSSettingsBreadcrumb}>
        <RecordPerPage
          perPage={perPage}
          onChange={(perPageSize: number) => {
            dispatch(setPerPage(perPageSize));
          }}
        />
      </ToolBar>
      <ContentBox>
        <Listing
          moduleInfo={moduleInfo}
          handleEditClick={(data: any) => {
            dispatch(setDetails(data));
            setEditDrawer(true);
          }}
          handleDeleteClick={setDeleteValue}
        />
        <EditComponent
          titleName={moduleInfo.title}
          open={editDrawer}
          close={() => dispatch(setDetails(null)) && setEditDrawer(false)}
        />
        <DeleteModal
          title={moduleInfo.title}
          deleteValues={deleteValue}
          callApi={deleteRecord}
          close={() => setDeleteValue(null)}
        />
      </ContentBox>
    </>
  );
};

export default Cms;
